import React, { useState, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Record from './Record';
import Register from './Register';

import {
  Card,
  CardContent,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  Grid
} from '@material-ui/core';

import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  container: {
    maxHeight: 415,
    minHeight: 415
  }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Results = ({ resultset, resultModes, icon, vision, selectedMode, openEdition, openDeletion, openTreatment, openExportDialog, selected, handleSelect, selectExpense, values, stock }) => {

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if (event.currentTarget.id == 'excel' || event.currentTarget.id == 'csv' || event.currentTarget.id == 'pdf') {
      openExportDialog(event.currentTarget.id);
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (event) => {
    setAnchorEl(null);
  };

  return (
    <Fragment>

      {(screen.width <= 480 || selectedMode == MODE_COMPACT) ? (

        <Box mt={3}>
          <Grid
            container
            spacing={2}
          >
            {(resultModes[MODE_COMPACT].export != LEVEL_ACCESS_HIDE) ? (
              <Grid
                item
                md={12} xl={12} >
                <Card>
                  <CardContent>
                    <Fragment>
                      <Button
                        disabled={resultModes[MODE_COMPACT].export == LEVEL_ACCESS_DISABLED}
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.button}
                        startIcon={<SaveIcon />}
                        aria-controls="simple-menu" component="span" aria-haspopup="true" onClick={handleClick}>
                        Exportar
                      </Button>
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={handleClick} name="excel" id="excel" >Planilha do Excel</MenuItem>
                        <MenuItem onClick={handleClick} name="csv" id="csv" disabled>Arquivo de Texto CSV</MenuItem>
                        <MenuItem onClick={handleClick} name="csv" id="pdf" disabled>Arquivo PDF</MenuItem>
                      </Menu>
                    </Fragment>

                  </CardContent>
                </Card>
              </Grid>
            ) : ('')}

            {resultset.rows.map((item) => (
              <Record
                icon={icon}
                item={item}
                vision={vision}
                resultMode={resultModes[MODE_COMPACT]}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                selected={selected}
                handleSelect={handleSelect}
                selectExpense={selectExpense}
                values={values}
                stock={stock}>
              </Record>
            ))}
          </Grid>
        </Box>

      ) : (
        <Card className={classes.root}>
          <CardContent>
            <TableContainer component={PerfectScrollbar} className={classes.container}>

              <Table stickyHeader size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    {resultModes[MODE_FULL].columns.map((col) => (
                      (col.size != -1) ? (
                        <TableCell width={col.size} >
                          {col.name}
                        </TableCell>
                      ) : (
                        <TableCell>
                          {col.name}
                        </TableCell>
                      )
                    ))}

                    <TableCell align='right' width={25} >
                      {(resultModes[MODE_FULL].export != LEVEL_ACCESS_HIDE) ? (
                        <Fragment>
                          <Button
                            disabled={resultModes[MODE_FULL].export == LEVEL_ACCESS_DISABLED}
                            variant="contained"
                            color="secondary"
                            size="small"
                            className={classes.button}
                            startIcon={<SaveIcon />}
                            aria-controls="simple-menu" component="span" aria-haspopup="true" onClick={handleClick}>
                            Exportar
                          </Button>
                          <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                          >
                            <MenuItem onClick={handleClick} name="excel" id="excel" >Planilha do Excel</MenuItem>
                            <MenuItem onClick={handleClick} name="csv" id="csv" disabled>Arquivo de Texto CSV</MenuItem>
                            <MenuItem onClick={handleClick} name="csv" id="pdf" disabled>Arquivo PDF</MenuItem>
                          </Menu>
                        </Fragment>
                      ) : (<div></div>)}

                    </TableCell>

                  </TableRow>
                </TableHead>

                <TableBody>
                  {resultset.rows.map((item) => (
                    <Register
                      icon={icon}
                      item={item}
                      vision={vision}
                      resultMode={resultModes[MODE_FULL]}
                      openEdition={openEdition}
                      openDeletion={openDeletion}
                      openTreatment={openTreatment}
                      selected={selected}
                      handleSelect={handleSelect}
                      selectExpense={selectExpense}
                      values={values}
                      stock={stock}>
                    </Register>
                  ))}

                  {(resultset.rows.length == 0) ? (
                    <TableRow  >
                      <TableCell colSpan={resultModes[MODE_FULL].columns.length + 1} align="center" >
                        {resultModes[MODE_FULL].empty}
                      </TableCell>
                    </TableRow>
                  ) : ('')}

                </TableBody>
              </Table>

            </TableContainer>
          </CardContent>
        </Card>
      )
      }

    </Fragment >
  );
};

export default Results;
